module.exports = __webpack_public_path__ + "img/b3ec73626282a1daac038cb2ea9f2bb9.png";